<template>
    <Breadcrumbs main="Bonus Ui" title="Owl Carousel" />
    <div class="container-fluid">
        <div class="row">
            <slidesOnly />
            <withControls />
            <autoPlay />
            <mouseWheel />
            <withIndicators />
            <withCaptions />
            <crossFade />
            <individualCarousel />
            <disableTouch />
            <darkVariant />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const slidesOnly = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/slidesOnly.vue"))
const withControls = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withControls.vue"))
const autoPlay = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/autoPlay.vue"))
const mouseWheel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/mouseWheel.vue"))
const withIndicators = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withIndicators.vue"))
const withCaptions = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/withCaptions.vue"))
const crossFade = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/crossFade.vue"))
const individualCarousel = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/individualCarousel.vue"))
const disableTouch = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/disableTouch.vue"))
const darkVariant = defineAsyncComponent(() => import("@/components/theme/advance/owlcarousel/darkVariant.vue"))
</script>